<template>
  <div
    class="size-full overflow-y-auto overflow-x-hidden py-12 sm:px-6 lg:px-8"
  >
    <div class="flex min-h-full flex-col justify-center">
      <div class="sm:mx-auto sm:w-full sm:max-w-md">
        <div class="flex items-center justify-center px-8">
          <IconBrandLogo class="h-auto w-full" />
        </div>
      </div>

      <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <BaseCard class="relative">
          <BaseTabs
            v-model="logInType"
            :tabs="logInTypeOptions"
          />

          <ControlLoginRequestLinkForm
            v-if="logInType === 'email-link'"
          />
          <ControlLoginEmailPasswordForm v-else />
        </BaseCard>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { isLoggedIn } = useAuth()
const { navigateToHome } = useNavigateToHome()

const logInType = ref("email-link")

const logInTypeOptions = [
  {
    value: "email-link",
    label: "Email Link",
  },
  {
    value: "password",
    label: "Password",
  },
]

whenever(
  () => isLoggedIn.value,
  () => navigateToHome(),
  { immediate: true }
)
</script>
